import React from 'react';
import { observer } from 'mobx-react';

import SubmissionActivitiesStore from 'stores/EntitiesFormSubmission/SubmissionActivities';

import AddCommentActivities from 'ui/AddCommentActivities';
import FeedComponent from 'ui/Feed';
import { DefaultFeedMapping } from 'ui/Feed/Feed';

import { useStore } from 'utils/hooks/store';

import { ScrollableContainer, CommentLayout } from 'containers/UserDetails/components/UserActivities/styles';

import { ActivityMapping } from 'utils/api/types';

import { CenteredCircularProgress } from 'components/Progress';

import { Container, SubmissionActivityContainer, SubmissionActivityWrapper } from './styles';

const PADDING_BOTTOM_ACTIVITIES = 120;

const EntityFormPublicSubmissionActivity: React.FunctionComponent = (): React.ReactElement => {
  const scrollableRef = React.useRef<HTMLDivElement | null>(null);
  const [keepBottom, setKeepBottom] = React.useState(true);
  const { entitiesFormSubmission } = useStore();
  const activities = entitiesFormSubmission.submissionActivities as unknown as SubmissionActivitiesStore;

  const onScroll = (e: React.UIEvent<HTMLDivElement>): void => {
    // @ts-ignore
    const bottom = e.target.clientHeight;
    // @ts-ignore
    const scrolledAt = e.target.scrollHeight - e.target.scrollTop;
    const shouldKeepBottom = scrolledAt - bottom <= PADDING_BOTTOM_ACTIVITIES;

    if (shouldKeepBottom !== keepBottom) {
      setKeepBottom(shouldKeepBottom);
    }
  };

  const onSizeChanged = (newHeight: number): void => {
    if (keepBottom && scrollableRef.current) {
      scrollableRef.current.scrollTop = newHeight;
    }
  };

  if (activities === undefined || activities.activities === undefined) {
    return (
      <Container>
        <CenteredCircularProgress />
      </Container>
    );
  }

  if (entitiesFormSubmission.submissionActivities?.updatingActivities) {
    return <CenteredCircularProgress />;
  }

  return (
    <SubmissionActivityContainer>
      <SubmissionActivityWrapper>
        <Container>
          <ScrollableContainer
            onScroll={onScroll}
            ref={scrollableRef}
            style={{
              height: 'fit-content',
              maxHeight: activities.activities.length > 0 ? '500px' : '',
            }}
          >
            <CommentLayout style={{ padding: activities.activities.length > 0 ? '20px 24px 0px' : '0' }}>
              <FeedComponent
                // @ts-ignore
                originalActivities={{ ...activities, hasMore: false }}
                mapping={{ ...DefaultFeedMapping } as unknown as ActivityMapping}
                onSizeChanged={onSizeChanged}
                sessionUser={{ name: 'Reporter', uuid: 'reporter-uuid' }}
                onDeleteFile={activities.removeActivity}
                onDeleteComment={activities.removeActivity}
                nonEditable
              />
            </CommentLayout>
          </ScrollableContainer>
          <AddCommentActivities
            borderless
            placeholder="Add any additional notes, pictures or files"
            // @ts-ignore
            uploadFile={activities.addSubmissionFile}
            // @ts-ignore
            sendMessage={activities.addSubmissionMessage}
          />
        </Container>
      </SubmissionActivityWrapper>
    </SubmissionActivityContainer>
  );
};

export default observer(EntityFormPublicSubmissionActivity);
